// extracted by css-extract-rspack-plugin
export default {"AuthCardContainer":"AuthCardContainer-WMlIpf","authCardContainer":"AuthCardContainer-WMlIpf"};